/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CommentDto } from '../../models/comment-dto';
import { CreatePostCommentDto } from '../../models/create-post-comment-dto';

export interface PostClientControllerCreateCommentV1$Params {
  id: string;
      body: CreatePostCommentDto
}

export function postClientControllerCreateCommentV1(http: HttpClient, rootUrl: string, params: PostClientControllerCreateCommentV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CommentDto>> {
  const rb = new RequestBuilder(rootUrl, postClientControllerCreateCommentV1.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CommentDto>;
    })
  );
}

postClientControllerCreateCommentV1.PATH = '/api/v1/posts/client/{id}/comment';
